exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qtd_product[readonly][data-v-0f62cf0e]{background:#fff;opacity:.7}", ""]);

// exports
